/* eslint-disable eqeqeq */
import moment from "moment";
import React, { useState } from "react";
import { API, fileUpload, get } from "../../config";
import Confirmation from "../Confirmation";
import { Label } from "../ui/label";
import CustomLabelText from "../CustomLabelText";
import { PhoneInput } from "../ui/phone-input";
import { Checkbox } from "../ui/checkbox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faClock,
  faLandmark,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "../ui/button";
import { useOrganization } from "../../lib/context/OrganisationContext";
import ReactInputMask from "react-input-mask";
import { cn } from "../../lib/utils";
import {
  Calendar,
  Clock3,
  Download,
  FileSpreadsheet,
  RefreshCcw,
  Send,
} from "lucide-react";

const KYCVerifyModal = ({
  setLoading,
  values,
  loading,
  index,
  verificationTypes,
  kycId,
  setFieldValue,
  method,
  organizationData,
  verifyStatus,
  errors,
  handleChange,
  handleBlur,
  fetchData,
  mainData,
}) => {
  const { fetchOrganizationContext } = useOrganization();
  const [showUsage, setShowUsage] = useState(false);
  const [checkVerify, setCheckVerify] = useState(false);
  const [confirmVerify, setConfirmVerify] = useState(false);
  const [showResend, setShowResend] = useState(false);

  const [smsDate, setSMSDate] = useState(
    mainData?.kyc?.verifications[index]?.sms_sent_date
      ? mainData?.kyc?.verifications[index]?.sms_sent_date
      : "",
  );

  const [kycData, setKycData] = useState({
    kyb_report_file: values?.kyb_report_file,
  });

  const used =
    values?.type == 2
      ? organizationData?.kyc_details?.kyb?.used
      : organizationData?.kyc_details?.kyc?.used;
  const total =
    values?.type == 2
      ? organizationData?.kyc_details?.kyb?.total
      : organizationData?.kyc_details?.kyc?.total;

  const toggleShowResend = () => {
    setShowResend(!showResend);
  };

  const toggleConfirmVerify = () => {
    setConfirmVerify(!confirmVerify);
  };

  const toggleCheckVerify = () => {
    setCheckVerify(!checkVerify);
  };

  const toggleShowUsage = () => {
    setShowUsage(!showUsage);
  };

  const handleVerifyCheck = async () => {
    try {
      setLoading(true);

      const { data } = await get(
        `${API.GET_CDD_VERFIY_CHECK}/${kycId ? kycId : ""}`,
      );
      toggleCheckVerify();
      fetchOrganizationContext();
      if (data?.data) {
        setSMSDate(data?.data?.sms_sent_date);
        setFieldValue(`verifications.${index}.verified`, data?.data?.verified);
        setFieldValue(
          `verifications.${index}.date_verified`,
          data?.data?.date_verified
            ? moment(data?.data?.date_verified, "DD-MM-YYYY")
            : null,
        );
        setFieldValue(
          `verifications.${index}.verified_by`,
          data?.data?.verified_by_id,
        );
        setFieldValue(`verifications.${index}.id`, data?.data?.id);
        setFieldValue(`verifications.${index}.type`, data?.data?.type);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (method == 3 || values?.type == 2) {
        fetchOrganizationContext();
      }
    }
  };

  const handleResend = async () => {
    try {
      setLoading(true);

      const { data } = await get(
        `${API.GET_CDD_RESEND}/${kycId ? kycId : ""}?organization_id=${
          organizationData?.organizationData?.id
            ? organizationData?.organizationData?.id
            : ""
        }`,
      );

      if (data?.data) {
        setFieldValue(`verifications.${index}.verified`, data?.data?.verified);
        setFieldValue(
          `verifications.${index}.date_verified`,
          data?.data?.date_verified
            ? moment(data?.data?.date_verified, "DD-MM-YYYY")
            : null,
        );
        setFieldValue(
          `verifications.${index}.verified_by`,
          data?.data?.verified_by_id,
        );
        setFieldValue(`verifications.${index}.id`, data?.data?.id);
        setFieldValue(`verifications.${index}.type`, data?.data?.type);
      }
      setLoading(false);
      toggleShowResend();
      toggleConfirmVerify();
    } catch (error) {
      setLoading(false);
      if (method == 3 || values?.type == 2) {
        fetchData();
        fetchOrganizationContext();
      }
    }
  };

  const handleVerifyID = async () => {
    try {
      setLoading(true);

      const formData = new FormData();

      values.mobile = values?.mobile
        ? `${values?.mobile}`.replace(/ /g, "")
        : "";

      formData.append("abn", values?.abn ? values?.abn : "");
      formData.append("acn", values?.acn ? values?.acn : "");

      formData.append("kyc_id", kycId ? kycId : "");

      formData.append(
        "organization_id",
        organizationData?.id ? organizationData?.id : "",
      );

      if (values?.type != 2) {
        const row = values.verifications[index];
        formData.append(
          "entity_type",
          values?.entity_type ? values?.entity_type : "",
        );

        formData.append("street", values?.street ? values?.street : "");
        formData.append("state_id", values?.state_id ? values?.state_id : "");
        formData.append(
          "suburb_id",
          values?.suburb_id ? values?.suburb_id : "",
        );
        formData.append(
          "postal_code",
          values?.postal_code ? values?.postal_code : "",
        );

        formData.append(
          "shipping_full_address",
          values?.shipping_full_address ? values?.shipping_full_address : "",
        );

        formData.append(
          "shipping_country_id",
          values?.shipping_country_id ? values?.shipping_country_id : "",
        );

        formData.append(
          "shipping_international_address",
          values.shipping_international_address ? "1" : "0",
        );

        formData.append(
          "shipping_street",
          values?.shipping_street ? values?.shipping_street : "",
        );
        formData.append(
          "shipping_state_id",
          values?.shipping_state_id ? values?.shipping_state_id : "",
        );
        formData.append(
          "shipping_suburb_id",
          values?.shipping_suburb_id ? values?.shipping_suburb_id : "",
        );
        formData.append(
          "shipping_postal_code",
          values?.shipping_postal_code ? values?.shipping_postal_code : "",
        );

        formData.append(
          "dob",
          values?.dob ? moment(values?.dob)?.format("DD-MM-YYYY") : "",
        );

        formData.append(
          "mobile",
          row?.mobile
            ? row?.mobile?.replace(/ /g, "")
            : values?.mobile != null
              ? values?.mobile
              : "",
        );
        formData.append(
          "cdd_customer_type",
          values?.cdd_customer_type ? values?.cdd_customer_type : "",
        );

        formData.append("risk", values?.risk ? values?.risk : "");

        formData.append("notes", values?.notes ? values?.notes : "");
        formData.append("ntf_note", values?.ntf_note ? values?.ntf_note : "");
        formData.append(
          "risk_assessment_id",
          values?.risk_assessment_id ? values?.risk_assessment_id : "",
        );

        formData.append(
          "compliance_manager_id",
          values?.compliance_manager_id ? values?.compliance_manager_id : "",
        );

        formData.append("reason", values?.reason ? values?.reason : "");

        formData.append("cdd", values?.cdd ? values?.cdd : "");

        if (values?.verifications?.length > 0) {
          values?.verifications?.forEach((row, index) => {
            // ▪ METHOD
            formData.append(
              `verifications[${index}][method]`,
              row.method ?? "",
            );

            // ▪ METHOD = 3 → TYPE
            if (row.id) {
              formData.append(`verifications[${index}][id]`, row.id ?? "");
            }

            formData.append(`verifications[${index}][type]`, row.type ?? "");

            formData.append(
              `verifications[${index}][date_verified]`,
              moment.isMoment(row.date_verified)
                ? row.date_verified.format("DD-MM-YYYY")
                : row.date_verified instanceof Date
                  ? moment(row.date_verified).format("DD-MM-YYYY")
                  : row.date_verified || "",
            );
            formData.append(
              `verifications[${index}][document_number]`,
              row.document_number ?? "",
            );

            formData.append(
              `verifications[${index}][verified_by]`,
              typeof row.verified_by === "object" && row.verified_by !== null
                ? row.verified_by.id || row.verified_by.verified_by_id || ""
                : row.verified_by || "",
            );
            formData.append(
              `verifications[${index}][verified]`,
              row.verified ?? "",
            );

            formData.append(
              `verifications[${index}][key]`,
              verificationTypes?.find((item) => item.id === row?.type)?.key &&
                row?.type
                ? verificationTypes?.find((item) => item.id === row?.type)?.key
                : "",
            );

            if (row.method === 3) {
              // ▪ Dynamic Fields
              if (row.dynamicFields) {
                Object.keys(row.dynamicFields).forEach((key) => {
                  let value = row.dynamicFields[key];

                  // If value is moment
                  if (moment.isMoment(value)) {
                    value = value.format(
                      value._f === "MM-YYYY" ? "MM-YYYY" : "DD-MM-YYYY",
                    );
                  }

                  // If value is JS Date
                  else if (value instanceof Date) {
                    value = moment(value).format("DD-MM-YYYY");
                  }

                  // If value is already MM-YYYY
                  else if (
                    typeof value === "string" &&
                    /^\d{2}-\d{4}$/.test(value)
                  ) {
                    // eslint-disable-next-line no-self-assign
                    value = value;
                  }

                  formData.append(
                    `verifications[${index}][fields][${key}]`,
                    value ?? "",
                  );
                });
              }
            }
          });
        }
      }
      const { data } = await fileUpload(
        `${values?.type == 2 ? API.GET_CDD_VERFIY_KYB_CONTACT : API.GET_CDD_VERFIY_CONTACT}`,
        formData,
      );
      fetchOrganizationContext();
      if (values?.type != 2) {
        setFieldValue(`verifications.${index}.verified`, data?.data?.verified);
        setFieldValue(
          `verifications.${index}.date_verified`,
          data?.data?.date_verified
            ? moment(data?.data?.date_verified, "DD-MM-YYYY")
            : null,
        );
        setFieldValue(
          `verifications.${index}.verified_by`,
          data?.data?.verified_by_id,
        );
        setFieldValue(`verifications.${index}.id`, data?.data?.id);
      } else {
        setFieldValue(
          `beneficiaries`,
          data?.data?.beneficiaries?.length > 0
            ? data?.data?.beneficiaries
            : "",
        );
        setKycData(data?.data);
        fetchData();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (method == 3 || values?.type == 2) {
        fetchData();
        fetchOrganizationContext();
      }
    }
  };

  const handleDownloadKYB = async (fileUrl) => {
    try {
      setLoading(true);
      const export_report_path = fileUrl;
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        // ✅ ADD THIS LINE FOR SAFARI
        a.setAttribute("target", "_blank");
        a.setAttribute("download", file[file.length - 1] || "contractor.xls");
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoading(false);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  return (
    <>
      {kycData?.kyb_report_file ? (
        <>
          <div className="flex bg-webPrimary rounded-md w-fit">
            <Button
              className="bg-transparent flex items-center gap-1 px-2"
              onClick={(e) => {
                e.preventDefault();
                handleDownloadKYB(kycData?.kyb_report_file);
              }}
            >
              <FileSpreadsheet size={18} />
              KYB Report
            </Button>

            <Button
              onClick={(e) => {
                e.preventDefault();
                handleDownloadKYB(kycData?.kyb_report_file);
              }}
              className="bg-transparent border-l border-white dark:border-black rounded-none px-2 rounded-se-md rounded-ee-md"
            >
              <Download size={18} />
            </Button>
          </div>
        </>
      ) : (
        <>
          {(verifyStatus == 2 || verifyStatus == 3) && method == 2 && (
            <Button
              onClick={(e) => {
                e.preventDefault();
                toggleShowResend();
              }}
              className={"w-fit mr-2"}
            >
              <div className="flex items-center gap-1">
                <Send size={14} />
                <span>Resend</span>
              </div>
            </Button>
          )}
          <Button
            onClick={(e) => {
              e.preventDefault();
              (verifyStatus === 0 || !verifyStatus) &&
                toggleConfirmVerify(index);
            }}
            className={
              verifyStatus === 1
                ? values?.type == 2
                  ? "bg-[#096600] w-fit"
                  : "bg-[#0da500] w-fit"
                : verifyStatus === 2
                  ? "bg-[#f59e0b] w-fit"
                  : verifyStatus === 3
                    ? "bg-red-500 w-fit"
                    : "w-fit"
            }
          >
            <div className="flex items-center gap-1">
              {/* <Verified size={18} /> */}
              {verifyStatus === 1 ? (
                <FontAwesomeIcon
                  icon={values?.type == 2 ? faLandmark : faCheckCircle}
                  size="1x"
                  title="Pass"
                  className="rag-white"
                />
              ) : verifyStatus === 2 ? (
                <FontAwesomeIcon
                  icon={faClock}
                  size="1x"
                  title="Pending"
                  className="rag-white"
                />
              ) : verifyStatus === 3 ? (
                <FontAwesomeIcon
                  icon={faClock}
                  size="1x"
                  title="Expired"
                  className="rag-white"
                />
              ) : (
                ""
              )}
              <span>
                {verifyStatus === 1
                  ? "Verified"
                  : verifyStatus === 2
                    ? "Pending"
                    : verifyStatus === 3
                      ? "Expired"
                      : "Verify"}
              </span>
            </div>
          </Button>
          {verifyStatus === 2 ? (
            <>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  toggleCheckVerify(index);
                }}
                className={"w-fit ml-2"}
              >
                <div className="flex items-center gap-1">
                  <RefreshCcw size={14} />
                  <span>Show</span>
                </div>
              </Button>
            </>
          ) : (
            <></>
          )}

          {verifyStatus == 2 && method == 2 && smsDate && (
            <>
              <div className="flex items-center gap-4 text-sm">
                <b>SMS Sent Date:</b>
                <span className="flex items-center gap-1.5">
                  <Calendar className="h-4 w-4" />
                  {moment(smsDate, "DD-MM-YYYY HH:mm:ss").format("DD MMM YYYY")}
                </span>

                <span className="flex items-center gap-1.5">
                  <Clock3 className="h-4 w-4" />
                  {moment(smsDate, "DD-MM-YYYY HH:mm:ss").format("hh:mm:ss A")}
                </span>
              </div>
            </>
          )}
        </>
      )}
      <Confirmation
        title={`Resend Request`}
        open={showResend}
        setOpen={setShowResend}
        toggleShow={() => {
          toggleShowResend();
        }}
        className="sm:max-w-1/2"
        message={
          <>
            <div>
              <p>
                <b>Are you sure you want to resend this request?</b>
              </p>
              <p>
                Your previous verification link will be disabled, and a new
                request will be sent. This will use one additional credit.
              </p>
            </div>
          </>
        }
        loading={loading}
        disabled={loading}
        okAction={async () => {
          handleResend();
        }}
        cancelAction={() => {
          setShowResend(!showResend);
        }}
      />

      <Confirmation
        title={"Check Status"}
        open={checkVerify}
        setOpen={setCheckVerify}
        toggleShow={() => {
          toggleCheckVerify();
        }}
        className="sm:max-w-1/2"
        message={
          <>
            <div>Would you like check the kyc verification status?</div>
          </>
        }
        okAction={async () => {
          handleVerifyCheck();
        }}
        cancelAction={() => {
          setCheckVerify(!checkVerify);
        }}
      />

      <Confirmation
        title={"Verify Data"}
        open={confirmVerify}
        setOpen={setConfirmVerify}
        toggleShow={() => {
          toggleConfirmVerify();
        }}
        className="sm:max-w-1/2"
        message={
          <>
            <div>Are you sure you want to verify the record?</div>
            <div className="grid grid-cols-1 text-left mt-2">
              {values?.type == 2 ? (
                <>
                  <div className="grid gap-2 mb-2">
                    <Label htmlFor="abn">
                      <CustomLabelText
                        // required={values?.entity_type === "1" ? true : false}
                        required={false}
                        labelText="ABN"
                        errorField={errors?.abn}
                      />
                    </Label>
                    <ReactInputMask
                      id="abn"
                      type="text"
                      name="abn"
                      value={values?.abn ? values?.abn : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      mask="99 999 999 999"
                      maskChar={null}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.abn
                          ? `${cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                            )} focus-visible:ring-red-500 border-red-500`
                          : cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                            )
                      }
                    />
                  </div>

                  <div className="flex items-center gap-3 my-4">
                    <div className="h-px flex-1 bg-border" />
                    <span className="text-xs font-semibold uppercase text-muted-foreground">
                      OR
                    </span>
                    <div className="h-px flex-1 bg-border" />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="acn">
                      <CustomLabelText
                        // required={values?.entity_type === "1" ? true : false}
                        required={false}
                        labelText="ACN"
                        errorField={errors?.acn}
                      />
                    </Label>
                    <ReactInputMask
                      id="acn"
                      type="text"
                      name="acn"
                      value={values?.acn ? values?.acn : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      mask="999 999 999"
                      maskChar={null}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.acn
                          ? `${cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                            )} focus-visible:ring-red-500 border-red-500`
                          : cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                            )
                      }
                    />
                  </div>
                </>
              ) : (
                <div className="grid gap-2">
                  <Label htmlFor="phone">
                    <CustomLabelText
                      required={method === 2 ? true : false}
                      labelText="Mobile No."
                      errorField={""}
                    />
                  </Label>
                  <PhoneInput
                    onChange={(e) => {
                      setFieldValue(`verifications.${index}.mobile`, e);
                    }}
                    value={
                      values?.verifications[index]?.mobile
                        ? values?.verifications[index]?.mobile
                        : values?.mobile
                    }
                    defaultValue={"+61"}
                    defaultCountry={"AU"}
                    minLength={15}
                    maxLength={15}
                  />
                </div>
              )}
              <div className="flex items-start space-x-2 mt-4">
                <Checkbox
                  id="terms"
                  checked={values?.consent}
                  name="same_address"
                  onClick={() => {
                    setFieldValue(`consent`, !values?.consent);
                  }}
                />
                <label
                  htmlFor="terms"
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-justify"
                >
                  {values?.type == 2
                    ? `I confirm that I am authorised to act on behalf of this company and consent to
                      the company’s beneficial ownership information being checked with document
                      issuers or official record holders via third-party systems for the purpose of
                      identifying and verifying the company’s ultimate beneficial owners.`
                    : `I confirm that I am authorised to conduct this identity check
                  and I consent to information being checked with the document
                  issuer or official record holder via third party systems for
                  the purpose of confirming customer identity. Would you like
                  Myna Australia Pty Ltd to verify the id now?`}
                </label>
              </div>
            </div>
          </>
        }
        disabled={
          values?.type == 2
            ? !(values?.consent && (values?.abn || values?.acn))
            : method === 2
              ? !values?.verifications?.[index]?.mobile && !values?.consent
              : !values?.consent
        }
        okAction={async () => {
          toggleShowUsage();
        }}
        cancelAction={() => {
          setConfirmVerify(!confirmVerify);
        }}
      />

      <Confirmation
        title={`${values?.type == 2 ? "KYB" : "KYC"} Usage`}
        open={showUsage}
        setOpen={setShowUsage}
        toggleShow={() => {
          toggleShowUsage();
        }}
        className="sm:max-w-1/2"
        message={
          <>
            <div>{`Warning: Sending this verification will consume one ${values?.type == 2 ? "KYB" : "KYC"} token. Current usage is ${used} out of ${total}; upon confirmation, usage will increase to ${used + 1}.`}</div>
          </>
        }
        loading={loading}
        disabled={loading}
        okAction={async () => {
          handleVerifyID();
          toggleShowUsage();
          toggleConfirmVerify();
        }}
        cancelAction={() => {
          setShowUsage(!showUsage);
        }}
      />
    </>
  );
};

export default KYCVerifyModal;
